var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraph = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "icon icon-graph",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28.92,3.62a1,1,0,0,0-.54-.54A1,1,0,0,0,28,3H23a1,1,0,0,0,0,2h2.59L17,13.59l-3.29-3.3a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L13,12.41l3.29,3.3a1,1,0,0,0,1.42,0L27,6.41V9a1,1,0,0,0,2,0V4A1,1,0,0,0,28.92,3.62Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 6,
  x: 5,
  y: 22,
  rx: 1,
  ry: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 11,
  y: 17,
  rx: 1,
  ry: 1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 10,
  x: 17,
  y: 18,
  rx: 1,
  ry: 1
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 15,
  x: 23,
  y: 13,
  rx: 1,
  ry: 1
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraph);
export default ForwardRef;